import { getApps, initializeApp } from 'firebase/app';
import { connectDatabaseEmulator, getDatabase } from 'firebase/database';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import {
  getFirebaseConfig,
  isDevHost,
  resolveFirebaseEnv,
} from './firebase.config.js';

const firebaseConfig = getFirebaseConfig();
const firebaseEnv = resolveFirebaseEnv();
const useFirebaseEmulators =
  process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true' ||
  firebaseEnv === 'localhost';

// Must match firebase.json emulators.functions/database ports.
const functionsEmulatorPort = Number(
  process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || 6001
);
const databaseEmulatorPort = Number(
  process.env.REACT_APP_DATABASE_EMULATOR_PORT || 10000
);
const emulatorHost = 'localhost';

function getOrInitApp() {
  const existing = getApps().find(
    (app) => app.options.projectId === firebaseConfig.projectId
  );
  if (existing) {
    return existing;
  }
  return initializeApp(firebaseConfig);
}

const app = getOrInitApp();

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.info(
    `[firebase] env=${firebaseEnv} projectId=${firebaseConfig.projectId} host=${typeof window !== 'undefined' ? window.location.hostname : 'ssr'} emulators=${useFirebaseEmulators}`
  );
}

if (isDevHost() && firebaseConfig.projectId === 'roitool' && !useFirebaseEmulators) {
  // eslint-disable-next-line no-console
  console.error(
    '[firebase] Dev host is using production project roitool. Hard-refresh (Cmd+Shift+R) or restart the dev server.'
  );
}

// Initialize Firebase Database
export const database = getDatabase(app);

// Functions deploy to us-central1 (must match Cloud Functions region).
export const functions = getFunctions(app, 'us-central1');

if (useFirebaseEmulators && typeof window !== 'undefined') {
  connectDatabaseEmulator(database, emulatorHost, databaseEmulatorPort, {
    disableWarnings: true,
  });
  connectFunctionsEmulator(functions, emulatorHost, functionsEmulatorPort);
}

export { firebaseConfig, firebaseEnv };
export default app;
